<template>
  <AcademyHomepage :toggleShowAdminFolders="toggleShowAdminFolders">
    <StorageFilesPage
      :searchValue="formValues.searchValue"
      :isShowAdminFoldersCallback="isShowAdminFolders"
      :toggleShowAdminFolders="toggleShowAdminFolders"
    />
  </AcademyHomepage>
</template>

<script>
import StorageFilesPage from "@/views/academy/storage/files/StorageFilesPage";
import AcademyHomepage from "@/views/academy/home/AcademyHomepage";

export default {
  name: "StoragePage",
  components: {
    AcademyHomepage,
    StorageFilesPage
  },
  data: () => ({
    formValues: {
      searchValue: ""
    },
    isShowAdminFolders: false
  }),
  methods: {
    toggleShowAdminFolders(value) {
      this.isShowAdminFolders = value;
    }
  }
};
</script>

<style scoped></style>
